import { Box, Typography } from '@mui/material'
import React from 'react'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'
import CloseModal from './CloseModal'

const Header = ({ isEdit }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingX: '24px',
        paddingY: '20px',
        borderBottom: '1px solid #E5E5E5',
        bgcolor: 'background.main',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        <Box
          sx={{
            borderRadius: '50%',
            color: 'alternate.main',
            bgcolor: 'alternate.light',
            aspectRatio: 1,
            width: 40,
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CalendarMonthOutlinedIcon sx={{ color: 'alternate.main' }} />
        </Box>
        <Typography variant="h4" fontWeight="bold" color="dark-text.main">
          {isEdit ? 'Edit' : 'Schedule an'} interview
        </Typography>
      </Box>
      <CloseModal />
    </Box>
  )
}

export default Header
